import { client } from "api";
import { Booking } from "models/Booking";

export type GetBookingsRequest = {
  orderNumber?: string | null,
  userId?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  officeId?: number | null,
  excludeDone?: boolean | null,
  excludeInternal?: boolean | null,
};

export type GetBookingsResponse = Booking[];

export const getBookings = (request: GetBookingsRequest) =>
  client.get<GetBookingsResponse>("/booking", { params: request }).then((res) => res.data);
